define( function() {

	// Match a standalone tag
	return ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/core/var/rsingleTag.js
// module id = 35
// module chunks = 0